import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireRole } from '../guards/RequireRole';
import AppLayout from '../../components/AppLayout';
import ClientHome from '../../features/client/pages/ClientHome';
import ClientProfile from '../../features/client/pages/ClientProfile';
import TripDetails from '../../features/client/pages/TripDetails';
import MyBookings from '../../features/client/pages/MyBookings';
import BookingDetails from '../../features/client/pages/BookingDetails';
import Messages from '../../features/client/pages/Messages';
import HostApplication from '../../features/client/pages/HostApplication';

export const ClientRoutes = () => {
  return (
    <RequireRole roles="client">
      <AppLayout>
        <Routes>
          <Route path="home" element={<ClientHome />} />
          <Route path="profile" element={<ClientProfile />} />
          <Route path="trips" element={<Navigate to="/available-listings" replace />} />
          <Route path="trips/:tripId" element={<TripDetails />} />
          <Route path="bookings" element={<MyBookings />} />
          <Route path="bookings/:bookingId" element={<BookingDetails />} />
          <Route path="messages" element={<Messages />} />
          <Route path="host-application" element={<HostApplication />} />
        </Routes>
      </AppLayout>
    </RequireRole>
  );
};

